import { CampaignPerformanceGeneralType } from '@features/campaigns/performance/components/MetricChart/MetricChart.types.ts';
import { apiRoutes } from '@features/campaigns/performance/consts/apiRoutes.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { CampaignId } from '@shared/types/campaign.ts';

export async function fetchGeneralMetrics(campaignId: CampaignId): Promise<CampaignPerformanceGeneralType | null> {
  return await apiClient.get<CampaignPerformanceGeneralType | null>(apiRoutes.getCampaignReportingGeneral(campaignId));
}
